module.exports = __webpack_public_path__ + "media/images/brand/meta_icons/favicon-3495f6b1aa637316727ef7ad05f3c9a3.ico";